/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SupporterRankUpNotificationActionData } from './SupporterRankUpNotificationActionData';
import {
    SupporterRankUpNotificationActionDataFromJSON,
    SupporterRankUpNotificationActionDataFromJSONTyped,
    SupporterRankUpNotificationActionDataToJSON,
} from './SupporterRankUpNotificationActionData';

/**
 * 
 * @export
 * @interface SupporterRankUpNotificationAction
 */
export interface SupporterRankUpNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof SupporterRankUpNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof SupporterRankUpNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof SupporterRankUpNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {SupporterRankUpNotificationActionData}
     * @memberof SupporterRankUpNotificationAction
     */
    data: SupporterRankUpNotificationActionData;
}

/**
 * Check if a given object implements the SupporterRankUpNotificationAction interface.
 */
export function instanceOfSupporterRankUpNotificationAction(value: object): value is SupporterRankUpNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function SupporterRankUpNotificationActionFromJSON(json: any): SupporterRankUpNotificationAction {
    return SupporterRankUpNotificationActionFromJSONTyped(json, false);
}

export function SupporterRankUpNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupporterRankUpNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': SupporterRankUpNotificationActionDataFromJSON(json['data']),
    };
}

export function SupporterRankUpNotificationActionToJSON(value?: SupporterRankUpNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': SupporterRankUpNotificationActionDataToJSON(value.data),
    };
}

